import { css } from "@emotion/react";
import { ThemedCssCreator } from "../../../../config/emotion";

export const activeWrapperCss: ThemedCssCreator = (theme) => css`
  color: ${theme.colors.secondaryColor};
  border-color: ${theme.colors.secondaryColor};
`;

export const wrapperCss: ThemedCssCreator = (theme) => css`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-width: 2px;
  border-radius: 2px;
  border-color: #eeeeee;
  border-style: dashed;
  background-color: #fafafa;
  color: #bdbdbd;
  outline: none;
  transition: border 0.24s;

  &:active,
  &:hover {
    ${activeWrapperCss(theme)};
  }
`;
